import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconDescription.tsx
const OutlinedFilledDescription = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M319-248h322v-71H319v71Zm0-170h322v-71H319v71ZM229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h363l234 234v523q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm313-570h189L542-811v186Z" })
});
const OutlinedDescription = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M319-248h322v-71H319v71Zm0-170h322v-71H319v71ZM229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h363l234 234v523q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm313-570v-186H229v662h502v-476H542ZM229-811v186-186 662-662Z" })
});
const RoundedFilledDescription = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M355-248h251q14.9 0 24.95-10.57Q641-269.14 641-284.07T630.95-309Q620.9-319 606-319H354q-14.9 0-24.95 10.07-10.05 10.07-10.05 25t10.55 25.43Q340.1-248 355-248Zm0-170h251q14.9 0 24.95-10.57Q641-439.14 641-454.07T630.95-479Q620.9-489 606-489H354q-14.9 0-24.95 10.07-10.05 10.07-10.05 25t10.55 25.43Q340.1-418 355-418ZM229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h323q19.31 0 37.16 8Q607-890 620-877l177 177q13 13 21 30.84 8 17.85 8 37.16v483q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm313-617q0 19.75 13.63 33.37Q569.25-625 589-625h142L542-811v139Z" })
});
const RoundedDescription = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M355-248h251q14.88 0 24.94-10.37t10.06-25.7q0-14.91-10.06-24.92Q620.88-319 606-319H354q-14.87 0-24.94 10.09-10.06 10.09-10.06 25t10.35 25.41Q339.7-248 355-248Zm0-170h251q14.88 0 24.94-10.37t10.06-25.7q0-14.91-10.06-24.92Q620.88-489 606-489H354q-14.87 0-24.94 10.09-10.06 10.09-10.06 25t10.35 25.41Q339.7-418 355-418ZM229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-662q0-39.46 27.48-67.23Q189.95-906 229-906h323q19.56 0 37.28 8Q607-890 620-877l177 177q13 13 21 30.72t8 37.28v483q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm313-617v-139H229v662h502v-476H589q-19.75 0-33.37-13.63Q542-652.25 542-672ZM229-811v186-186 662-662Z" })
});
const SharpFilledDescription = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M319-248h322v-71H319v71Zm0-170h322v-71H319v71ZM135-55v-851h457l234 234.3V-55H135Zm407-570h189L542-811v186Z" })
});
const SharpDescription = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M319-248h322v-71H319v71Zm0-170h322v-71H319v71ZM135-55v-851h457l234 234.3V-55H135Zm407-570v-186H229v662h502v-476H542ZM229-811v186-186 662-662Z" })
});
const componentMap = {
	outlined: OutlinedDescription,
	"outlined-fill": OutlinedFilledDescription,
	rounded: RoundedDescription,
	"rounded-fill": RoundedFilledDescription,
	sharp: SharpDescription,
	"sharp-fill": SharpFilledDescription
};
const IconDescription = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconDescription };